import { css } from 'lit';

export default css`
  :host {
    --private-item-bgcolor: rgba(245, 245, 245, 0.5);
  }

  .card-summary {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }

  .card-summary > img {
    width: 120px;
    height: 120px;
    object-fit: cover;
  }

  .card-summary > amityeko-tg-title::part(base) {
    margin-top: 10px;
  }

  .card-summary-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  amityeko-tg-body-two::part(base) {
    color: var(--amityeko-color-gray-5);
  }

  .card-summary-content > amityeko-tg-body-two:first-child {
    padding-right: 10px;
  }

  .card-summary-content > amityeko-tg-body-two:last-child {
    border-left: 1px solid var(--amityeko-color-gray-8);
    padding-left: 10px;
  }

  .recognition-list {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .recoginition-list-item {
    display: flex;
    align-items: center;
    padding: 8px 16px 8px 60px;
    gap: 12px;
    background-color: var(--amityeko-color-font-light);
    border-radius: 8px;
    cursor: pointer;
  }

  .recoginition-list-item:hover {
    background: var(--private-item-bgcolor);
  }

  .recoginition-list-item > img {
    width: 40px;
    height: 40px;
  }

  .recoginition-item-block {
    display: block;
    position: relative;
    width: 4px;
    height: 40px;
    border-radius: 2px;
    background-color: var(--amityeko-color-gray-8);
  }

  amityeko-button {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
